export enum RestrictionTypeListType {
  Boolean = 'boolean',
  Number = 'number',
  Time = 'time'
}

export enum RestrictionTypeListId {
  Closed = 'closed',
  ClosedOnArrival = 'closedOnArrival',
  ClosedOnDeparture = 'closedOnDeparture',
  MinimumStayArrival = 'minimumStayArrival',
  MaximumStayArrival = 'maximumStayArrival',
  MinimumStay = 'minimumStay',
  MaximumStay = 'maximumStay',
  ExactStay = 'exactStay',
  ExactStayArrival = 'exactStayArrival',
  Release = 'release',
  RoomToSell = 'roomToSell',
  MaxAnticipation = 'maxAnticipation'
}

export interface RestrictionTypeList {
  id: RestrictionTypeListId
  name: string
  selected: boolean
  value: string
}

export const RestrictionInputTypeMap: {
  [key in RestrictionTypeListId]: RestrictionTypeListType
} = {
  closed: RestrictionTypeListType.Boolean,
  closedOnArrival: RestrictionTypeListType.Boolean,
  closedOnDeparture: RestrictionTypeListType.Boolean,
  exactStay: RestrictionTypeListType.Number,
  exactStayArrival: RestrictionTypeListType.Number,
  maximumStay: RestrictionTypeListType.Number,
  maximumStayArrival: RestrictionTypeListType.Number,
  minimumStay: RestrictionTypeListType.Number,
  minimumStayArrival: RestrictionTypeListType.Number,
  roomToSell: RestrictionTypeListType.Number,
  release: RestrictionTypeListType.Time,
  maxAnticipation: RestrictionTypeListType.Time
}
